<template>
  <div class="p-video">
    <!-- 輪播區塊 -->
    <div class="p-video-hot">
      <div class="p-video-hot__container container">
        <h1 class="p-video__title">
          熱門影音
        </h1>
        <!-- Carousel -->
        <div class="p-video__carousel">
          <img ref="carouselSupportSceneRef" class="support-scene" src="https://static.ctwant.com/images/dist/video_carousel_support-scene.gif" alt="撐畫面高度用">
          <!-- Player -->
          <div class="p-video__carousel-content swiper-container swiper-no-swiping carousel-screen">
            <div class="swiper-wrapper">
              <div
                v-for="(item, index) in carousels"
                :key="item.video_id"
                class="swiper-slide"
              >
                <img src="https://static.ctwant.com/images/dist/video_carousel_support-scene.gif" alt="撐畫面高度用">
                <div :id="`youtubeIframe-${index}`" class="swiper-slide-img" />
                <!-- <div class="swiper-lazy-preloader" /> -->
              </div>
            </div>
            <!-- Carousel arrow -->
            <div v-show="!isSwiperGalleryLoading" class="p-video__carousel-arrow">
              <button slot="button-prev" type="button" class="swiper-carousel-button-prev" title="上一則影音">
                <span>
                  <img src="https://static.ctwant.com/images/dist/arrow-point-to-left.svg" alt="上一則影音圖示">
                </span>
              </button>
              <button slot="button-next" type="button" class="swiper-carousel-button-next" title="下一則影音">
                <span>
                  <img src="https://static.ctwant.com/images/dist/arrow-point-to-right.svg" alt="下一則影音圖示">
                </span>
              </button>
            </div>
          </div>

          <!-- Thumbs -->
          <div
            ref="carouselGalleryRef"
            :class="{loading: isSwiperGalleryLoading}"
            class="p-video__carousel-gallery swiper-container gallery-thumbs"
          >
            <div class="swiper-wrapper">
              <div
                v-for="item in carousels"
                :key="item.video_id"
                class="swiper-slide swiper-lazy"
              >
                <img :src="item.cover.lg" :alt="item.caption">
                <div class="swiper-lazy-preloader swiper-lazy-preloader-white" />
                <!-- <a class="m-card--mle-2" :href="`/video/${item.video_id}/`">
                  {{ item.title }}
                </a> -->
                <span v-show="false" :data-href="`/video/${item.video_id}`" :data-title="item.title" />
              </div>
            </div>
            <!-- Thumbs arrow -->
            <div class="swiper-arrow">
              <button slot="button-prev" type="button" class="swiper-thumbs-button-prev" title="往上查看更多影音">
                <div>
                  <img src="https://static.ctwant.com/images/dist/arrow-point-to-left.svg" alt="往上查看更多影音圖示">
                </div>
              </button>
              <button slot="button-next" type="button" class="swiper-thumbs-button-next" title="往下查看更多影音">
                <div>
                  <img src="https://static.ctwant.com/images/dist/arrow-point-to-right.svg" alt="往下查看更多影音圖示">
                </div>
              </button>
            </div>
          </div>

          <!-- Info -->
          <a
            class="p-video__carousel-info"
            :href="`/video/${swiperFirstInfo.id}/`"
            title="前往影音新聞頁"
            @click="routerTo"
          >
            <span class="m-card__title m-card--mle-1">
              {{ swiperFirstInfo.title }}
            </span>
            <span>
              立即查看
            </span>
          </a>
        </div>
      </div>
    </div>

    <!-- 系列類別區塊 -->
    <div class="p-video__body container">
      <div class="p-video__content">
        <!-- 手機側邊欄 -->
        <SideBarForMobile
          :data="{popular}"
          :type="'video'"
        />
        <!-- 手機側邊欄 -->

        <div
          v-for="seriesItem in seriesSorts"
          :key="seriesItem.series_sort_id"
          class="l-section"
        >
          <h2 class="l-section__title-with-hr">
            {{ seriesItem.title }}
          </h2>
          <hr>
          <div class="l-section__content">
            <div class="row">
              <nuxt-link
                v-for="videoItem in articleShower(seriesItem.videos, 6, 4)"
                :key="videoItem.video_id"
                :to="`/video/${videoItem.video_id}/`"
                class="m-card col-sm-4 col-6"
                title="前往影音新聞頁"
              >
                <div class="e-video__img-container">
                  <LazyImage
                    :src="selectImageSize(videoItem.cover)"
                    :alt="videoItem.caption"
                    class="m-card__img"
                    width="250"
                    height="131"
                  />
                  <!-- <div class="e-video__icon-wrapper">
                    <div class="e-video__icon" />
                  </div> -->
                </div>
                <h3 class="m-card__title m-card--mle-2">
                  {{ videoItem.title }}
                </h3>
              </nuxt-link>
            </div>
            <nuxt-link :to="`/series-sort/${seriesItem.series_sort_id}/`" :title="`前往${seriesItem.title}影音類別頁`" class="e-btn-more">
              看更多
              <svg class="e-btn__arrow-r" viewBox="0 0 8 15">
                <title>{{ `前往${seriesItem.title}影音類別頁` }}</title>
                <path d="M7.712 8.243l-6.034 6.45a.938.938 0 01-1.39 0 1.102 1.102 0 010-1.486L5.628 7.5.287 1.793a1.102 1.102 0 010-1.485.939.939 0 011.39 0l6.034 6.45c.192.205.288.473.288.742s-.096.538-.288.743z" fill-rule="nonzero" />
              </svg>
            </nuxt-link>
          </div>
        </div>
      </div>
      <!-- 側邊欄 -->
      <SideBar
        :data="{popular, tags}"
        :type="'video'"
      />
      <!-- 側邊欄 -->
    </div>
  </div>
</template>

<script>
/* global YT */
import { mapGetters } from 'vuex'
import { Swiper, Navigation, Autoplay, Thumbs, Lazy, EffectFade } from 'swiper/js/swiper.esm'
import LazyImage from '@/components/LazyImage.vue'
import SideBar from '@/components/SideBar.vue'
import SideBarForMobile from '@/components/SideBarForMobile.vue'
import articleHelpers from '@/utils/articleHelpers.js'
Swiper.use([Navigation, Autoplay, Thumbs, Lazy, EffectFade])

export default {
  components: {
    LazyImage,
    SideBar,
    SideBarForMobile
  },
  mixins: [articleHelpers],
  async asyncData({ $axios, params, route, error }) {
    const api = $axios.defaults.baseURL
    const videoApiUrl = `${api}/video`

    try {
      const { data } = await $axios.$get(videoApiUrl)
      return {
        carousels: data.carousel,
        popular: data.popular,
        seriesSorts: data.series_sorts,
        tags: data.tags,
        main_category: '影音',
        swiperFirstInfo: {
          title: data.carousel[0].title,
          id: data.carousel[0].video_id
        }
      }
    } catch (e) {
      console.error('VideoIndex', {
        code: e.response.data.code,
        message: e.response.data.message,
        method: e.response.config.method,
        url: e.response.config.url
      })
      error({ statusCode: 404 })
    }
  },
  data() {
    return {
      pageTitle: 'CTWANT 影音首頁',
      carousels: null,
      popular: null,
      seriesSorts: [],
      tags: [],
      main_category: '',
      swiper: null,
      swiperGallery: null,
      isSwiperGalleryLoading: true,
      isSwiperGallerySwiping: false,
      // isGalleryFirstDown: false,
      timer: null,
      swiperFirstInfo: {
        title: '',
        id: 0
      },
      players: {
        player0: null,
        player1: null,
        player2: null,
        player3: null,
        player4: null,
        player5: null,
        player6: null,
        player7: null,
        player8: null,
        player9: null
      },
      componentScreenWidth: 0
    }
  },
  head() {
    const hostAndNeedBackslashPath = this.HOST + (this.$route.path.substr(this.$route.path.length - 1) === '/' ? this.$route.path : `${this.$route.path}/`)
    const websiteCategory = {
      '@context': 'http://schema.org',
      '@type': 'Website',
      author: {
        '@type': 'Person',
        name: 'CTWANT'
      },
      creator: {
        '@type': 'Person',
        name: 'CTWANT'
      },
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': hostAndNeedBackslashPath
      },
      publisher: {
        '@type': 'Organization',
        name: 'CTWANT',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.ctwant.com/images/dist/logo.png'
        }
      },
      dateCreated: this.$config.companyCreatedTimeZone,
      datePublished: this.$config.companyCreatedTimeZone,
      dateModified: this.carousels.length > 0 ? this.carousels[0].publish_at_time_zone ? this.carousels[0].publish_at_time_zone : '' : '',
      headline: this.pageTitle,
      name: this.pageTitle,
      url: hostAndNeedBackslashPath,
      keywords: this.tags ? this.tags.slice(0, 10).join() : '',
      description: this.carousels.length > 0 ? this.carousels.map(item => item.title).slice(0, 3).join(', ') : this.pageTitle
    }
    const HotNewsListItem = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: this.popular.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          image: item.cover.md,
          url: `https://www.ctwant.com/video/${item.video_id}`
        }
      }).slice(0, 5)
    }
    return {
      title: `${this.pageTitle}`,
      meta: [
        { hid: 'ogUrl', property: 'og:url', content: hostAndNeedBackslashPath },
        { hid: 'ogTitle', property: 'og:title', content: `${this.pageTitle}` },
        { hid: 'videoPublished_time', name: 'pubdate', property: 'video:published_time', itemprop: 'datePublished', content: this.$config.companyCreatedTimeZone },
        { hid: 'videoModified_time', name: 'lastmod', property: 'video:modified_time', itemprop: 'dateModified', content: websiteCategory.dateModified }
      ],
      link: [
        { hid: 'alternate', rel: 'alternate', hreflang: 'zh-Hant', href: hostAndNeedBackslashPath },
        { hid: 'canonical', rel: 'canonical', href: hostAndNeedBackslashPath }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        { innerHTML: JSON.stringify(websiteCategory), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(HotNewsListItem), type: 'application/ld+json' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'HOST',
      'WIDTH_PAD',
      'WIDTH_MOBILE',
      'isLaptop',
      'isMobile'
    ]),
    showThumbsNum() {
      return !this.isLaptop ? 4 : 3
    },
    carouselGalleryRefDirection() {
      return !this.isMobile ? 'vertical' : 'horizontal'
    },
    articleShower() {
      const vm = this
      const mobileWidth = this.WIDTH_MOBILE

      return function (data, pc, mobile = pc) {
        if (vm.componentScreenWidth > mobileWidth) {
          return data.slice(0, pc)
        } else {
          return data.slice(0, mobile)
        }
      }
    },
    selectImageSize() {
      const sw = this.componentScreenWidth
      return function (imageArr) {
        let imgUrl = null

        if (sw <= this.WIDTH_PAD) {
          imgUrl = imageArr.sm
        } else {
          imgUrl = imageArr.md
        }
        return imgUrl
      }
    }
  },
  /*
  watch: {
    isGalleryFirstDown(nowBool, prevBool) {
      if (nowBool === false && prevBool === true && this.isSwiperGallerySwiping === true) {
        this.isSwiperGallerySwiping = false
        this.$refs.carouselGalleryRef.querySelector('.swiper-wrapper').style.pointerEvents = 'auto'
      }
    }
  },
  */
  mounted() {
    // console.log('carousels: ', this.carousels)
    // console.log('popular: ', this.popular)
    this.componentScreenWidth = this.screenWidth || window.screen.width
    this.$nextTick(() => {
      this.initSwiper()
      this.$store.dispatch('ad/displayAd')
      this.$store.dispatch('ad/registerAndDisplayPopupAd', { type: this.main_category })

      window.YT.ready(() => {
        this.initYoutubePlayer(0)

        const { carouselSupportSceneRef, carouselGalleryRef } = this.$refs
        this.timer = setTimeout(() => {
          if (!this.isMobile) {
            carouselGalleryRef.style.height = (carouselSupportSceneRef.clientHeight + 60) + 'px'
          }
          this.isSwiperGalleryLoading = false
        }, 1500)
      })

      this.$gtm.push({
        event: 'domMounted',
        pageUrl: this.$route.fullPath,
        pageTitle: this.pageTitle,
        pageCategory: this.main_category
      })
    })
  },
  updated() {
    this.$nextTick(() => {
      this.initSwiper()
      if (this.swiper && this.swiper.navigation) {
        // console.log('this.swiper.navigation.update()')
        this.swiper.navigation.update()
      }
    })
  },
  beforeDestroy() {
    this.swiperGallery = null
    this.swiper = null
    this.players = {
      player0: null,
      player1: null,
      player2: null,
      player3: null,
      player4: null,
      player5: null,
      player6: null,
      player7: null,
      player8: null,
      player9: null
    }
    clearTimeout(this.timer)
  },
  methods: {
    initSwiper() {
      const vm = this
      window.YT.ready(() => {
        this.swiperGallery = new Swiper('.gallery-thumbs', {
          // spaceBetween: !vm.isLaptop ? 5 : 5,
          spaceBetween: 5,
          slidesPerView: vm.showThumbsNum,
          // slidesPerGroup: 2, // 幾個一組，這樣會一次移動一組而不是單個
          // slideToClickedSlide: true,
          // freeMode: true, // 拖曳完後自動貼合 default: false會貼合, true不會貼合
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          observer: true, // 修改swiper自己或子元素時，自動初始化swiper
          observeParents: true, // 修改swiper的父元素時，自動初始化swiper
          navigation: {
            nextEl: '.swiper-thumbs-button-next',
            prevEl: '.swiper-thumbs-button-prev'
          },
          preloadImages: false,
          lazy: true,
          // preventClicks: true, // 拖曳過程中，點擊到的那個直接觸發 default: true不會, false會
          // preventClicksPropagation: true, // 拖曳過完後，點擊到的那個直接觸發 default: true不會, false會
          direction: vm.carouselGalleryRefDirection, // swiper 方向 'vertical', default: 'horizontal'
          touchStartPreventDefault: false, // 是否阻止 mouse event & touch event 事件, default: true
          // touchMoveStopPropagation: true, // 是否阻止 touch 的冒泡事件, default: false
          allowTouchMove: false, // 是否能拖動, true能拖, false不能拖, default: true
          touchAngle: 15, // 能拖移成功的角度， default:45
          // resistanceRatio: !vm.isMobile ? 0.85 : 0.5 // 拖移到最邊緣時，露出底色的抗拒力，數值0~1, 數值越小抗拒力越大, default:0.85
          on: {
            click() {
              if (vm.swiper) {
                vm.swiper.activeIndex = this.clickedIndex
              }
            }
          }
        })

        this.swiper = new Swiper('.carousel-screen', {
          // spaceBetween: 10,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: '.swiper-carousel-button-next',
            prevEl: '.swiper-carousel-button-prev'
          },
          thumbs: {
            swiper: vm.swiperGallery
          },
          preloadImages: false,
          // lazy: true,
          on: {
            // init() {},
            slideChangeTransitionEnd() {
              // console.log('this.activeIndex: ', this.activeIndex)
              // console.log('vm.swiper.activeIndex: ', vm.swiper.activeIndex)
              vm.players[`player${this.previousIndex}`].stopVideo()
              if (!vm.players[`player${this.activeIndex}`]) {
                vm.initYoutubePlayer(this.activeIndex)
              } else if (vm.players[`player${this.activeIndex}`] && typeof vm.players[`player${this.activeIndex}`].playVideo === 'function') {
                vm.players[`player${this.activeIndex}`].playVideo()
              }
              // 不知道為什麼在 swiper slideChange 使用 vue set 後 swiper thumbs 會一直自動跳回第一筆。迫不得已使用原生方式改呈現資料。
              // document.querySelector('.p-video__carousel-info > .m-card__title').innerHTML = document.querySelector('.swiper-slide-thumb-active > a').innerHTML
              // document.querySelector('.p-video__carousel-info').href = document.querySelector('.swiper-slide-thumb-active > a').href
              document.querySelector('.p-video__carousel-info > .m-card__title').innerHTML = document.querySelector('.swiper-slide-thumb-active > span').dataset.title
              document.querySelector('.p-video__carousel-info').href = document.querySelector('.swiper-slide-thumb-active > span').dataset.href
            }
          }
        })
      })
    },
    onYoutubePlayerReady(e) {
      e.target.mute() // 播放時靜音
      // e.target.playVideo() // 強制播放(手機才會自動播放，但僅限於Android)
    },
    onYoutubePlayerStateChange(e) {
      if (e.data === YT.PlayerState.ENDED) {
        e.target.stopVideo()
        if (this.swiper) {
          if ((this.swiper.activeIndex + 1) >= Object.keys(this.players).length) {
            this.swiper.slideTo(0)
          } else {
            this.swiper.slideNext()
          }
        }
      }
    },
    initYoutubePlayer(active) {
      this.players[`player${active}`] = new YT.Player(`youtubeIframe-${active}`, {
        videoId: this.carousels[active].youtube_id, // YouTube 影片ID
        // width: '1080', // 播放器寬度 (px)
        // height: '720', // 播放器高度 (px)
        playerVars: {
          // autoplay: active === 0 ? 1 : 0, // 自動播放影片
          autoplay: 1,
          enablejsapi: 1,
          origin: window.location.origin,
          host: `${window.location.protocol}//www.youtube.com`,
          widget_referrer: window.location.origin,
          controls: 0, // 顯示播放器
          modestbranding: 1, // 隱藏YouTube Logo
          // loop: 1, // 重覆播放
          // playlist: carouselItem.youtube_id, // 當使用影片要重覆播放時，需再輸入YouTube 影片ID
          fs: 0, // 隱藏全螢幕按鈕
          cc_load_policy: 0, // 隱藏字幕
          iv_load_policy: 3, // 隱藏影片註解
          rel: 0,
          playsinline: 1,
          showinfo: 0
        },
        events: {
          onReady: this.onYoutubePlayerReady,
          onStateChange: this.onYoutubePlayerStateChange
        }
      })
    },
    routerTo(e) {
      // 這個的 <nuxt-link> 沒辦法使用nuxt原生 to 去跳頁
      // 主要因為 swiper slideChange 內使用 vue set, 就會造成 crash, 所以只能依靠傳統 js set
      // 這邊在用 this.$router.push 去抓連結跳頁
      e.preventDefault()
      this.$router.push(document.querySelector('.p-video__carousel-info').pathname)
    }
    /*
    swiperGalleryMousedown() {
      // @mousedown="swiperGalleryMousedown"
      this.isGalleryFirstDown = true
      setTimeout(() => {
        if (this.isGalleryFirstDown === true && this.isSwiperGallerySwiping === false) {
          this.isSwiperGallerySwiping = true
          this.$refs.carouselGalleryRef.querySelector('.swiper-wrapper').style.pointerEvents = 'none'
        }
      }, 200)
    },
    swiperGalleryMouseup() {
      // @mouseup="swiperGalleryMouseup"
      setTimeout(() => {
        this.isGalleryFirstDown = false
      }, 250)
    },
    swiperGalleryTouchstart() {
      // @touchstart="swiperGalleryTouchstart"
      // e.preventDefault()
      // e.stopPropagation()
      this.isGalleryFirstDown = true
    },
    swiperGalleryTouchmove() {
      // @touchmove="swiperGalleryTouchmove"
      // e.preventDefault()
      // e.stopPropagation()
      if (this.isGalleryFirstDown === true && this.isSwiperGallerySwiping === false) {
        this.isSwiperGallerySwiping = true
        this.$refs.carouselGalleryRef.querySelector('.swiper-wrapper').style.pointerEvents = 'none'
      }
    },
    swiperGalleryTouchend() {
      @touchend="swiperGalleryTouchend"
      // e.preventDefault()
      // e.stopPropagation()
      setTimeout(() => {
        this.isGalleryFirstDown = false
      }, 250)
    }
    */
  }
}
</script>

<style lang="css">
@import 'node_modules/swiper/css/swiper.min.css';
</style>
<style lang="scss" scoped>
@import '~/assets/scss/pages/_video';
</style>
